<app-input-popup (onChange)="doSearch($event)"  (onItemSelection)="onSelection($event)" [dropDownOptions]="options"></app-input-popup>
